<template>
    <div class="login-page-wrapper aboutpage" :class="{'bodyfont-unauth': !user}">
        <div class="over-lay"></div>
        <div class="container">
            <div class="row aboutrow">
                <div class="col-md-12">
                    <div class="main-content">
                        <h2 class="heading" v-bind:style="{ color: getCorpHeadingColor } ">About Us</h2>
                    </div>
                </div>
                <div class="col-sm-4 col-sm-offset-2" style="text-align:left">
                         <h3 v-if="beginSectionHeading" v-bind:style="{ color: getCorpHeadingColor } ">{{beginSectionHeading}}</h3>
                    <p style="text-align:left" v-if="beginSectionPara1" v-html="beginSectionPara1">
                        <!--Here at TONE we believe that being your personal and professional best is possible – and that when women help themselves and each other, we are truly unstoppable.-->
                        </p>
                    <p style="text-align:left" v-if="beginSectionPara2" v-html="beginSectionPara2">
                        <!--Our story started with  a simple observation: we are so capable and do so much, which leaves us with little time for ourselves.   We found that getting trusted advice online is not easy and can be time consuming.-->
                        </p>
                    <p style="text-align:left" v-if="beginSectionPara3" v-html="beginSectionPara3">
                        <!--And what if you want more than just help for yourself? What if you also want to give back by helping other women along the way?-->
                    </p>
                </div>
                <div class="col-sm-4 toneleftlogo" v-if="beginSectionImage">
                    <div class="aboutlogoholder">
                        <img :src="beginSectionImage" style="height: 508px;width: 315px;" alt="CEO IMAGE" title="Gemma Toner">
                    </div>
                </div>
                <div class="clearfix"></div>
                <div class="col-sm-8 mtop30 col-sm-offset-2">
                         <h4 v-if="createdSectionHeading" v-bind:style="{ color: getCorpHeadingColor } ">{{createdSectionHeading}}</h4>
                    <p v-if="createdSectionPara1" v-html="createdSectionPara1">
                        <!--At TONE, we get that  you are short on time and that you are usually last on your list.-->
                        <!--That’s why everything we do  is short, easy, and on your terms. We deliver expert videos-->
                        <!--on topics that are of interest to you like Money, Mind/Body Work and Life, so you can move-->
                        <!--forward in the direction you want to go.  We partner with really smart people who have proven-->
                        <!--themselves and their ideas in the real world. They genuinely care and are passionate about helping women.-->
                        <!--The best part, you let us know what topics interest you, and we will deliver customized expert videos straight-->
                        <!--to your inbox twice a week. We get it…you’re busy!-->
                    </p>
                    <p v-if="createdSectionPara2" v-html="createdSectionPara2">
                        <!--We recognize that each and every one of us has a lot to share.-->
                        <!--Our TONE Talks community discussions open the conversation to peer-to-peer advice on topics that-->
                        <!--matter the most.  We also engage our members with exclusive live streaming events hosted by our experts.-->
                        <!--Here, you can ask questions, or even share a personal experience.  We want to hear from you because we are truly-->
                        <!--better together.-->
                    </p>

                    <p v-if="createdSectionPara3" v-html="createdSectionPara3">
                        <!--We are glad you are here so you can begin to set the TONE of your life!-->
                    </p>
                </div>
                <div class="col-sm-12">
                    <h4 class="welcomemessage" v-if="bottomMessage1" v-html="bottomMessage1" v-bind:style="{ color: getCorpHeadingColor } ">
                        <!--We are so happy to see you.-->
                    </h4>
                    <h2 class="welcomemessage" v-bind:style="{ color: getCorpHeadingColor } ">
                        <b>{{bottomMessage2}}</b><br>
                        <small>{{bottomMessage3}}</small>
                    </h2>
                </div>
            </div>
            <div class="clearfix"></div>
            <div class="slider responsive-slick-imagelist" v-if="staffMembers">
                <!--<div v-for="member in staffMembers">-->
                    <div class="slide-player" v-for="member in staffMembers">
                        <img :src="member.memberImageUrl" :alt="member.memberFirstName" :title="member.memberFirstName"/>
                        <h4 class="text-center" v-bind:style="{ color: getCorpHeadingColor } ">{{member.memberFirstName}}<br /><small>{{member.position}}</small></h4>
                        <p>{{member.biography}}</p>
                    </div>
                <!--</div>-->
                <!--<div>-->
                    <!--<div class="slide-player">-->
                        <!--<img src="https://s3.amazonaws.com/tone-assets-prod/images/team/AnjaliHeadshot_rev.png"/>-->
                        <!--<h4 class="text-center">Anjali Walter<br /><small>Head of Operations</small></h4>-->
                    <!--</div>-->
                <!--</div>-->
                <!--<div>-->
                    <!--<div class="slide-player">-->
                        <!--<img src="https://s3.amazonaws.com/tone-assets-prod/images/team/val03.jpg"/>-->
                        <!--<h4 class="text-center">Valerie J. Green<br /><small>Marketing & Brand Strategy Consultant</small></h4>-->
                    <!--</div>-->
                <!--</div>-->
                <!--<div>-->
                    <!--<div class="slide-player">-->
                        <!--<img src="https://s3.amazonaws.com/tone-assets-prod/images/team/Mike-Sorrentino-Producer.png"/>-->
                        <!--<h4 class="text-center">Mike Sorrentino<br /><small>Producer</small></h4>-->
                    <!--</div>-->
                <!--</div>-->
                <!--&lt;!&ndash;<div>&ndash;&gt;-->
                    <!--<div class="slide-player">-->
                        <!--<img src="https://s3.amazonaws.com/tone-assets-prod/images/team/Elli-Zaverdas-Marketing-&-Sales-Director.png"/>-->
                        <!--<h4 class="text-center">Elli Zaverdas<br /><small>Marketing & Sales Director</small></h4>-->
                    <!--</div>-->
                <!--</div>-->
                <!--<div>-->
                    <!--<div class="slide-player">-->
                        <!--<img src="https://s3.amazonaws.com/tone-assets-prod/images/team/Paula-Doyle-VP-of-Development-and-Community.png"/>-->
                        <!--<h4 class="text-center">Paula Doyle<br /><small>VP of Development and Community</small></h4>-->
                    <!--</div>-->
                <!--</div>-->
                <!--<div>-->
                    <!--<div class="slide-player">-->
                        <!--<img src="https://s3.amazonaws.com/tone-assets-prod/images/team/Jonathan-Disegi-Brand-Consultant.png"/>-->
                        <!--<h4 class="text-center">Jonathan Disegi<br /><small>Brand Consultant</small></h4>-->
                    <!--</div>-->
                <!--</div>-->
                <!--<div>-->
                    <!--<div class="slide-player">-->
                        <!--<img src="https://s3.amazonaws.com/tone-assets-prod/images/team/Pippa-Schwarzkopf-Editor.png"/>-->
                        <!--<h4 class="text-center">Pippa Schwarzkopf<br /><small>Editor</small></h4>-->
                    <!--</div>-->
                <!--</div>-->
                <!--<div>-->
                    <!--<div class="slide-player">-->
                        <!--<img src="https://s3.amazonaws.com/tone-assets-prod/images/team/Dominique-Rollins-Editor.png"/>-->
                        <!--<h4 class="text-center">Dominique<br /><small>Editor</small></h4>-->
                    <!--</div>-->
                <!--</div>-->
                <!--<div>-->
                    <!--<div class="slide-player">-->
                        <!--<img src="https://s3.amazonaws.com/tone-assets-prod/images/team/Shiloh-Accuosti-Marketing-Assistant.png"/>-->
                        <!--<h4 class="text-center">Shiloh Accuosti<br /><small>Marketing Assistant</small></h4>-->
                    <!--</div>-->
                <!--</div>-->
            </div>
            <div class="clearfix"></div>
            <div class="contactformtexttone contact-form">
                <a href="javascript:" @click="$router.push('/become-expert')"><h3 v-bind:style="{ color: getCorpHeadingColor } ">Want to become a TONE Expert?</h3></a>
                <!--<p>-->
                    <!--TONE is a platform for women helping women in all areas of life. We look for experts in fields that can help women grow professionally and personally to live life to the fullest potential. Our experts are highly credentialed, successful in their fields and passionate about helping women. TONE underwrites production and related expenses, and experts are not paid a fee for their appearances. Please complete this form and tell us about yourself and why you would be a great addition to TONE.-->
                <!--</p>-->
                <!--<p>-->
                    <!--Fully completed forms should be sent to <a href="mailto:experts@tonenetworks.com"> experts@tonenetworks.com</a>-->
                <!--</p>-->
                <!--<p><a href="https://s3.amazonaws.com/assets.tonenetworks.com/resources/Become_Expert_Form.pdf" class="pinklinkcontectext" donwload="Become_Expert_Form.pdf" target="_blank"> Become a Tone Expert (PDF)</a></p>-->
            </div>
        </div>
    </div>
</template>

<script>
    import { input, spinner, alert } from 'vue-strap'
    import { mapGetters } from 'vuex'
    import slick from 'slick-carousel'
    import $ from 'jquery'

    export default {
        components: {
            'bs-input': input,
            'spinner': spinner,
            'alert': alert
        },
        metaInfo () {
            return {
                title: 'TONE | About US',
                meta: [
                    {property: 'og:image', content: 'https://assets.tonenetworks.com/images/tone_social_logo.jpg'},
                    {property: 'og:title', content: 'About US | TONE Networks'},
                    {property: 'og:site_name', content: 'TONE Networks | Expert Advice on Demand'},
                    {
                        property: 'og:description',
                        content: 'Here at TONE we believe that being your personal and professional best is possible – and that when women help themselves and each other, we are truly unstoppable.'
                    },
                    {property: 'twitter:title', content: 'About US | TONE Networks'},
                    {property: 'twitter:card', content: 'summary'},
                    {property: 'twitter:image', content: 'https://assets.tonenetworks.com/images/tone_social_logo.jpg'},
                    {
                        property: 'twitter:description',
                        content: 'Here at TONE we believe that being your personal and professional best is possible – and that when women help themselves and each other, we are truly unstoppable.'
                    },
                    {property: 'og:image:width', content: '300'},
                    {property: 'og:image:height', content: '300'}
                ]
            }
        },
        name: 'login',
        data: function () {
            return {
                success: false,
                successMsg: '',
                contactForm: {
                    emailAddress: '',
                    phoneNumber: '',
                    reason: '',
                    comments: ''
                },
                spinner: false,
                staffMembers: null,
                showMembers: false,
                beginSectionHeading: '',
                beginSectionImage: '',
                beginSectionPara1: '',
                beginSectionPara2: '',
                beginSectionPara3: '',
                beginSectionPara4: '',
                createdSectionHeading: '',
                createdSectionPara1: '',
                createdSectionPara2: '',
                createdSectionPara3: '',
                bottomMessage1: '',
                bottomMessage2: '',
                bottomMessage3: ''
            }
        },
        computed: {
            ...mapGetters([
                'error', 'user', 'getMembers', 'getAllSiteContents', 'getCorpHeaderColor', 'getCorpFooterColor', 'getCorpButtonColor', 'getCorpHeadingColor'
            ])
        },
        methods: {
            spinnerToggle () {
                this.spinner = !this.spinner
            },
            onSubmit () {
                if (this.contactForm.emailAddress && this.contactForm.phoneNumber) {
                    this.spinnerToggle()
                    this.$store.dispatch('SENDCONTACTUSFORM', this.contactForm).then(() => {
                        this.success = true
                        this.successMsg = 'Your message has been sent, we will get back to you shortly!'
                        this.spinnerToggle()
                    })
                }
            },
            setCarousal () {
                $.slick = slick
                const $slick = $(this.$el).find('.responsive-slick-imagelist')
                $slick.each(function () {
                    $slick.slick({
                        dots: false,
                        infinite: false,
                        speed: 300,
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        responsive: [{
                            breakpoint: 1024,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 1,
                                infinite: true,
                                dots: false
                            }
                        }, {
                            breakpoint: 600,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1
                            }
                        }, {
                            breakpoint: 480,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1
                            }
                        }]
                    })
                })
            },
            setDynamicSection (coll, key) {
                let valCol = coll.filter(x => {
                    return x.content_id === key
                })
                if (valCol && valCol.length > 0) {
                    return valCol[0].content_value
                } else {
                    return ''
                }
            }
        },
        watch: {
//            'staffMembers' (to, from) {
//                let self = this
//                if (self.staffMembers && self.staffMembers.length > 0) {
//                    setTimeout(() => {
//                        self.showMembers = true
//                        self.setCarousal()
//                    }, 1000)
//                }
//            }
        },
        mounted: function () {
            let self = this
           // this.setCarousal()
            self.$store.dispatch('GETSTAFFMEMBERS').then(() => {
                if (self.getMembers) {
                    self.staffMembers = self.getMembers
                    setTimeout(() => {
                        self.showMembers = true
                        self.setCarousal()
                    }, 2000)
                }
            })
            self.$store.dispatch('GETDYNAMICCONTENTS', 12).then(() => {
                if (self.getAllSiteContents) {
                    // How we Begin Section
                    self.beginSectionHeading = this.setDynamicSection(this.getAllSiteContents, 'HOW_WE_BEGAN_SECTION_HEADING')
                    self.beginSectionImage = this.setDynamicSection(this.getAllSiteContents, 'HOW_WE_BEGAN_SECTION_IMG_01')
                    self.beginSectionPara1 = this.setDynamicSection(this.getAllSiteContents, 'HOW_WE_BEGAN_SECTION_PARA_01')
                    self.beginSectionPara2 = this.setDynamicSection(this.getAllSiteContents, 'HOW_WE_BEGAN_SECTION_PARA_02')
                    self.beginSectionPara3 = this.setDynamicSection(this.getAllSiteContents, 'HOW_WE_BEGAN_SECTION_PARA_03')
                    self.beginSectionPara4 = this.setDynamicSection(this.getAllSiteContents, 'HOW_WE_BEGAN_SECTION_PARA_04')
                    // Created Section
                    self.createdSectionHeading = this.setDynamicSection(this.getAllSiteContents, 'WE_CREATED_TONE_HEADING')
                    self.createdSectionPara1 = this.setDynamicSection(this.getAllSiteContents, 'WE_CREATED_TONE_PARA_01')
                    self.createdSectionPara2 = this.setDynamicSection(this.getAllSiteContents, 'WE_CREATED_TONE_PARA_02')
                    self.createdSectionPara3 = this.setDynamicSection(this.getAllSiteContents, 'WE_CREATED_TONE_PARA_03')
                    self.createdSectionPara4 = this.setDynamicSection(this.getAllSiteContents, 'WE_CREATED_TONE_PARA_04')
                    // Bottom Messages
                    self.bottomMessage1 = this.setDynamicSection(this.getAllSiteContents, 'BOTTOM_MESSAGE_01')
                    self.bottomMessage2 = this.setDynamicSection(this.getAllSiteContents, 'BOTTOM_MESSAGE_02')
                    self.bottomMessage3 = this.setDynamicSection(this.getAllSiteContents, 'BOTTOM_MESSAGE_03')
                }
            })
            self.$store.dispatch('CACHEPAGE', window.location.href)
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    h2.heading {
        color: #f0617d;
        text-transform: capitalize;
        margin: 47px 0 35px 0;
        letter-spacing: 0.5px;
        font-family: sans-serif;
        font-size: 30px;
    }
    .aboutlogoholder {
        min-height: 300px;
        line-height: 300px;
    }

    .mtop30 {
        margin-top: 30px;
    }

    .row.aboutrow p {
        font-size: 17px;
        text-align: left;
        line-height: 1.5;
        letter-spacing: 2px;
    }
    h3 {
        color: #f0617d;
        letter-spacing: 4px;
        font-size: 24px;
        line-height: 1.5;
        margin: 30px 0 20px;
    }
    h4 {
        color: #f0617d;
        letter-spacing: 4px;
        font-size: 22px;
        text-align: left;
        line-height: 1.5;
    }
    h4.welcomemessage {
        text-align: center;
        margin: 50px 0 0;
        color: inherit;
        color: #f0617d;
    }

    h2.welcomemessage {
        letter-spacing: 8px;
        margin: 20px 0 60px;
        text-transform: uppercase;
    }
    .slide-player img {
        max-width: 100%;
    }
    @media(max-width:480px){
        body h4 {
            font-size: 18px !important;
        }

        h3 {
            font-size: 24px !important;
            line-height: 1.1 !important;
        }

        h2.welcomemessage {
            letter-spacing: 3px !important;
        }
    }
    html .slide-player {
        padding: 0 10px;
        margin: 0;
    }


</style>
<style>
    .aboutpage .slider.responsive-slick-imagelist.slick-initialized.slick-slider .slick-list {
        z-index: 0;
    }

    .aboutpage .slider.responsive-slick-imagelist.slick-initialized.slick-slider button {
        z-index: 50;
    }
    html .aboutpage .slide-player p{
        margin:0 0 10px;
        color: #a7a7a7;
        font-size: 18px;
    }
</style>



// WEBPACK FOOTER //
// AboutUs.vue?19b22e9e